import React from 'react';
import Page from '../../layout/Page';
import Updates from '../Updates';
import Feedback from '../Feedback';
import Button from '../../forms/Button';
import AggregateTips from '../AggregateTips';
import Buttn from '../../forms/Buttn';
import ModalFactory from '../../Modal';
import Col from '../../layout/Col';
import { SCREEN_WIDTH } from '../../../constants/config';

const Index = ({ ...props }) => {

    const routeToLegacy = () => {

        const route = () => {
            const host = window.location.hostname;
            if (host === 'localhost') {
                return 'https://localhost:44301/Home/Home#fromHosted'
            } else if (host === 'dev.hostedsolutions-dev.com') {
                return 'https://www.hostedsolutions-dev.com/Home/Home#fromHosted'
            } else {
                return 'https://www.hamiltonservices.com/web/Home/Home#fromHosted'
            }
        }

        ModalFactory.show({
            title: 'Why are you Heading back?',
            body: (
                <Col>
                    <span>To help us improve the new site, could you let us know why you're returning to the legacy version?</span>
                    <Feedback />
                </Col>
            ),
            buttons: [<Button to={route()}>To Legacy</Button>]
        })
    }

    //$(document).ready(() => {
    //    const routedFromHosted = document.cookie.split(';').find(e => e.includes('fromHosted'));

    //    if (routedFromHosted) {
    //        console.log('From Hosted');
    //        return;
    //    }

    //    const key = '#fromHosted';
    //    const local = window.location.hostname === 'localhost';
    //    const dev = window.location.hostname === 'www.hostedsolutions-dev.com';

    //    if (key === window.location.hash) {
    //        console.log('Routed From Hosted');
    //        document.cookie = 'fromHosted=true;path=/';
    //    } else {
    //        console.log('Routing Away');
    //        if (local) {
    //            window.location = 'http://localhost:3000/';
    //        } else if (dev) {
    //            window.location = 'https://dev.hostedsolutions-dev.com/';
    //        } else {
    //            window.location = 'https://hosted.hamiltonservices.com/';
    //        }
    //    }
    //})

    return (
        <Page
            title='Hamilton'
            icon='heading'
            tabs
            controls={[
                <Button
                    onClick={routeToLegacy}
                    label='To Legacy'
                />
            ]}
        >
            <AggregateTips tab='Info' />
            <Updates tab='Updates' />
            <Feedback tab='Feedback' />
        </Page>
    );
}

export default Index;